
// Wrapper for Google Identity Services and Google Calendar API

// You MUST replace this with your actual Google Cloud Project Client ID
const CLIENT_ID = '79007461100-02via27ficu8o1e43r12k15565moraoq.apps.googleusercontent.com';
const API_KEY = ''; // Optional if using Client ID for simple calls, but for Calendar API we usually need OAuth token (Client ID)
const DISCOVERY_DOC = 'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest';
const SCOPES = 'https://www.googleapis.com/auth/calendar.events';

let tokenClient: any;
let gapiInited = false;
let gisInited = false;

export const googleCalendarService = {

    // Initialize the Google API client
    loadScripts: () => {
        return new Promise<void>((resolve, reject) => {
            // Check if already loaded
            if (typeof (window as any).gapi !== 'undefined' && typeof (window as any).google !== 'undefined') {
                gapiInited = true;
                gisInited = true;

                // Ensure tokenClient is initialized even if scripts are loaded
                if (!tokenClient) {
                    tokenClient = (window as any).google.accounts.oauth2.initTokenClient({
                        client_id: CLIENT_ID,
                        scope: SCOPES,
                        callback: '', // defined at request time
                    });
                }

                resolve();
                return;
            }

            const script1 = document.createElement('script');
            script1.src = 'https://apis.google.com/js/api.js';
            script1.async = true;
            script1.defer = true;
            script1.onload = () => {
                (window as any).gapi.load('client', async () => {
                    await (window as any).gapi.client.init({
                        // apiKey: API_KEY, // Optional
                        discoveryDocs: [DISCOVERY_DOC],
                    });
                    gapiInited = true;
                    if (gisInited) resolve();
                });
            };

            const script2 = document.createElement('script');
            script2.src = 'https://accounts.google.com/gsi/client';
            script2.async = true;
            script2.defer = true;
            script2.onload = () => {
                tokenClient = (window as any).google.accounts.oauth2.initTokenClient({
                    client_id: CLIENT_ID,
                    scope: SCOPES,
                    callback: '', // defined at request time
                });
                gisInited = true;
                if (gapiInited) resolve();
            };

            document.body.appendChild(script1);
            document.body.appendChild(script2);
        });
    },

    // Ensure user is signed in
    authenticate: (): Promise<void> => {
        return new Promise((resolve, reject) => {
            if (CLIENT_ID.includes('YOUR_GOOGLE_CLIENT_ID_HERE')) {
                reject(new Error('Lütfen kaynak kodunda (src/services/googleCalendar.ts) GOOGLE_CLIENT_ID alanını kendi Client ID\'niz ile güncelleyin.'));
                return;
            }

            if (!gisInited || !gapiInited) {
                reject(new Error('Google API servisleri henüz yüklenmedi. Sayanın tamamen yüklenmesini bekleyin.'));
                return;
            }

            tokenClient.callback = async (resp: any) => {
                if (resp.error !== undefined) {
                    // If silent request failed (interaction_required), try with consent popup
                    if (resp.error === 'interaction_required' || resp.error === 'invalid_request') {
                        console.warn('Silent auth failed, trying consent...');
                        // Trigger consent popup. The callback will be called again with the result.
                        // We do NOT reject here, we assume the user will interact with the popup.
                        tokenClient.requestAccessToken({ prompt: 'consent' });
                        return;
                    }

                    // Specific error handling for popup closed or denied
                    if (resp.error === 'access_denied' || resp.error === 'popup_closed_by_user') {
                        reject(new Error('İzin verilmedi veya pencere kapatıldı.'));
                        return;
                    }

                    reject(resp);
                    return;
                }

                // Success! Set the token for gapi client
                if ((window as any).gapi) {
                    (window as any).gapi.client.setToken(resp);
                }
                resolve(resp);
            };

            // Always try silent auth first (prompt: '')
            // This prevents the 'Unverified App' screen from showing if already authorized
            tokenClient.requestAccessToken({ prompt: '' });
        });
    },

    // Create a meeting and return the link
    createMeeting: async (summary: string, startISO: string, endISO: string) => {
        try {
            const event = {
                'summary': summary,
                'start': {
                    'dateTime': startISO, // '2015-05-28T09:00:00-07:00'
                    'timeZone': Intl.DateTimeFormat().resolvedOptions().timeZone,
                },
                'end': {
                    'dateTime': endISO,
                    'timeZone': Intl.DateTimeFormat().resolvedOptions().timeZone,
                },
                'conferenceData': {
                    'createRequest': {
                        'requestId': Math.random().toString(36).substring(7),
                        'conferenceSolutionKey': {
                            'type': 'hangoutsMeet'
                        }
                    }
                }
            };

            const request = (window as any).gapi.client.calendar.events.insert({
                'calendarId': 'primary',
                'resource': event,
                'conferenceDataVersion': 1,
            });

            const response = await request;

            if (response.result.conferenceData && response.result.conferenceData.entryPoints) {
                const entryPoint = response.result.conferenceData.entryPoints.find((e: any) => e.entryPointType === 'video');
                if (entryPoint) {
                    return entryPoint.uri;
                }
            }

            // Fallback if no conference data returned (shouldn't happen if scope is correct)
            return response.result.htmlLink;

        } catch (err: any) {
            console.error('Error creating Google Meet:', err);
            throw new Error(err.result?.error?.message || 'Toplantı oluşturulamadı.');
        }
    }
};
